<ng-template #iconTemplate>
  <div class="dashboard-summary__header">
    <div class="dashboard-summary__title-group">
      <div class="dashboard-summary__title">{{title}}</div>
    </div>
  </div>
  <div class="dashboard-summary__items">
    @for (item of data; track item) {
      <div class="dashboard-summary__item-wrap">
        @if (item.fake) {
          <div class="dashboard-summary__spacer">
          </div>
        }
        @if (!item.fake) {
          <div class="dashboard-summary__item">
            @if (item.icon) {
              <div
                class="dashboard-summary__icon"
                [ngClass]="item.iconClasses ? item.iconClasses : ''">
                <mat-icon
                  class="text-current"
                [svgIcon]="item.icon"></mat-icon>
              </div>
            }
            <div class="dashboard-summary__content" [ngClass]="item.alignRight ? 'dashboard-summary__content--right' : ''">
              <div class="dashboard-summary__name"
              [ngClass]="item.alignRight ? 'dashboard-summary__name--emphasis' : ''">{{item.name}}</div>
              @if (item.isCurrency) {
                <div class="dashboard-summary__value" [ngClass]="item.textClass? item.textClass : 'text-2xl'"
                >{{item.value | currency:'EUR'}}</div>
              }
              @if (!item.isCurrency) {
                <div class="dashboard-summary__value" [ngClass]="item.textClass? item.textClass : 'text-2xl'"
                >{{item.value}}</div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</ng-template>
@if (!url) {
  <div class="dashboard-summary h-full">
    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
  </div>
}
@if (url) {
  <div class="dashboard-summary dashboard-summary--link h-full cursor-pointer" [routerLink]="url">
    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
  </div>
}


